"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var selectable_item_view_model_1 = require("./../../item-selector/selectable-item-view.model");
var ClaimItemViewModel = (function (_super) {
    __extends(ClaimItemViewModel, _super);
    function ClaimItemViewModel(claimType, claimNumber) {
        var _this = _super.call(this) || this;
        _this._claimType = claimType;
        _this._claimNumber = claimNumber;
        _this.updateValues();
        return _this;
    }
    Object.defineProperty(ClaimItemViewModel.prototype, "claimType", {
        get: function () {
            return this._claimType;
        },
        set: function (v) {
            this._claimType = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClaimItemViewModel.prototype, "claimNumber", {
        get: function () {
            return this._claimNumber;
        },
        set: function (v) {
            this._claimNumber = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    ClaimItemViewModel.fromClaimHeader = function (claimHeader) {
        var item = new ClaimItemViewModel(claimHeader.coverageShortName, claimHeader.claimFeatureNumber);
        return item;
    };
    ClaimItemViewModel.fromClaimDetail = function (claimDetail) {
        var item = new ClaimItemViewModel(claimDetail.coverageShortName, claimDetail.claimFeatureNumber);
        return item;
    };
    ClaimItemViewModel.prototype.updateValues = function () {
        this.preview = this.getPreview();
        this.title = this.getTitle();
        this.subTitle = this.getSubTitle();
    };
    ClaimItemViewModel.prototype.getPreview = function () {
        return "<b>" + this._claimType + ":</b> Claim #" + this._claimNumber;
    };
    ClaimItemViewModel.prototype.getTitle = function () {
        return "" + this._claimType;
    };
    ClaimItemViewModel.prototype.getSubTitle = function () {
        return "Claim Number # <b>" + this._claimNumber + "</b>";
    };
    ClaimItemViewModel.prototype.getSupplementalInformation = function () {
        return null;
    };
    return ClaimItemViewModel;
}(selectable_item_view_model_1.SelectableItemViewModel));
exports.ClaimItemViewModel = ClaimItemViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/claims/claim-item.model.js